import { Component, output, signal } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { KnowledgeBaseArticleDTOListing } from '../../../../../../common/dto/knowledge-base.dto';
import { MultilangTextPipe } from '../../../common/pipes/multilang-text.pipe';
import { select } from '@ngxs/store';
import { AppState } from '../../../app.state';
import { toSignal } from '@angular/core/rxjs-interop';
import { HelpSiteService } from '../../../common/services/help-site.service';
import { RouteNavigationService } from '../../../common/services/route-navigation.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { LoadingIndicatorComponent } from '../../../common/components/loading-indicator/loading-indicator.component';

@UntilDestroy()
@Component({
  selector: 'app-article-search-bar',
  imports: [
    MatInputModule,
    MatAutocompleteModule,
    MultilangTextPipe,
    FaIconComponent,
    LoadingIndicatorComponent,
  ],
  templateUrl: './article-search-bar.component.html',
  styleUrl: './article-search-bar.component.scss',
})
export class ArticleSearchBarComponent {
  private _searchText = new Subject<string | undefined>();

  constructor(
    private _helpSiteService: HelpSiteService,
    private _routeNavigationService: RouteNavigationService,
  ) {
  }

  public onSelected = output<void>();

  protected language = select(AppState.language);
  protected isLoading = signal(false);

  protected filteredArticles = toSignal<KnowledgeBaseArticleDTOListing[]>(
    this._searchText
      .pipe(
        debounceTime(250),
        distinctUntilChanged(),
        switchMap(async text => {
          if (!text) {
            return [];
          }

          this.isLoading.set(true);

          try {
            return await this._helpSiteService.searchArticlesAsync(text);
          } finally {
            this.isLoading.set(false);
          }
        }),
      )
    , { initialValue: <any>[] });

  protected onSearchTextChange(text: string) {
    this._searchText.next(text);
  }

  public async onArticleSelectedAsync(article: KnowledgeBaseArticleDTOListing, searchInput: HTMLInputElement) {
    searchInput.value = '';

    this.onSelected.emit();

    await this._routeNavigationService.goToArticleAsync(article);
  }

  protected readonly faSearch = faSearch;
}
